import { useContext, useMemo } from 'react';

import { AllEntitiesContext } from 'Screens/Dashboard/AllEntities/AllEntitiesProvider/AllEntitiesProvider';
import { EditEntityProvider } from 'Screens/Dashboard/AllEntities/EntityProvider/EditEntityProvider';
import EditEntity from 'Screens/Dashboard/AllEntities/EditEntity/EditEntity';
import { useGetEntitiesQuery } from 'api/entityEndpoints';

const EditEntityContainer = () => {
    const context = useContext(AllEntitiesContext);

    const entityId = context?.currentEntityId ?? undefined;

    const { data } = useGetEntitiesQuery();
    const currentEntity = useMemo(() => (data ?? []).find((entity) => entity.id === entityId), [entityId, data]);

    if (!currentEntity) {
        return null;
    }

    return (
        <EditEntityProvider currentEntity={currentEntity}>
            <EditEntity />
        </EditEntityProvider>
    );
};

export default EditEntityContainer;
